import React from "react";
import * as LucideIcons from "lucide-react";
import { conteudoPorNicho, nichosOrdenados } from "../data/conteudoPorNicho";

const NichoIcon = ({ name, className }) => {
  const Icon = LucideIcons[name] || LucideIcons.Briefcase;
  return <Icon className={className} />;
};

export default function Modal({ onSelecionar }) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-titulo"
      data-testid="modal-pre-qualificacao"
    >
      <div
        className="relative w-full max-w-5xl bg-[#111111] border border-white/10 rounded-2xl shadow-2xl shadow-green-500/10 p-6 md:p-12 animate-fade-in-up max-h-[95vh] overflow-y-auto"
      >
        {/* Glow decorativo */}
        <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-green-500/10 rounded-full blur-3xl" />

        <div className="relative flex flex-col items-center text-center mb-8 md:mb-10">
          <img
            src="/evolzap-logo-horizontal.png"
            alt="Evolzap"
            className="h-9 md:h-10 mb-6 md:mb-8"
          />
          <h2
            id="modal-titulo"
            className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-[1.1] max-w-3xl"
          >
            Qual é o seu tipo de negócio?
          </h2>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-zinc-400 max-w-xl">
            Personalize sua experiência e veja como o Evolzap funciona pro seu nicho
          </p>
        </div>

        <div
          className="relative grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4"
          data-testid="grid-nichos"
        >
          {nichosOrdenados.map((slug) => {
            const n = conteudoPorNicho[slug];
            return (
              <button
                key={slug}
                onClick={() => onSelecionar(slug)}
                data-testid={`nicho-card-${slug}`}
                className="group bg-[#1A1A1A] hover:bg-[#222222] border border-white/5 hover:border-green-500/30 rounded-xl p-4 md:p-6 transition-all duration-200 hover:scale-[1.04] hover:shadow-lg hover:shadow-green-500/10 flex flex-col items-center gap-3 text-center"
              >
                <span className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-green-500/10 group-hover:bg-green-500/20 flex items-center justify-center transition-colors">
                  <NichoIcon
                    name={n.icone}
                    className="w-6 h-6 md:w-7 md:h-7 text-green-500"
                  />
                </span>
                <span className="text-sm md:text-base text-white font-medium leading-tight">
                  {n.nome}
                </span>
              </button>
            );
          })}
        </div>

        <p className="relative mt-8 md:mt-10 text-center text-xs md:text-sm text-zinc-500">
          Sua escolha personaliza toda a página. Você pode trocar quando quiser.
        </p>
      </div>
    </div>
  );
}
